News
<template>
    <div class="news-wrap">
        <p class="new-mess">相关报导</p>
        <div class="news-con">
            <!-- <p class="media-news">媒体报道</p> -->
            <ul>
                <p>官方讯息</p> 
                <li class="news-item" v-for="item in newsTwo" :key="item.href">
                    <img v-lazy="`http://www.artgogo.com/online-exhibition/img/${item.img}`" alt="" />
                    <a target="_blank" :href="item.href">{{ item.mess }}</a>
                </li>
            </ul>
            <ul>
                <p>媒体报道</p> 
                <li class="news-item" v-for="item in newsOne" :key="item.href">
                    <img v-lazy="`http://www.artgogo.com/online-exhibition/img/${item.img}`" alt="" />
                    <a target="_blank" :href="item.href">{{ item.mess }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>
<style>
.news-wrap {
    position: absolute;
    width: 60%;
    height: 95%;
    left: 5%;
    top: 0;
}
.new-mess {
    color: #fff;
    font-size: 17px;
    margin: 30px 0px;
    text-align: left;
}
.news-con {
    height: 80%;
    border-radius: 4px;
    /* overflow-y: scroll; */
}
.news-con ul {
    overflow-y: auto;
    height: 100%;
    width: 43%;
    float: left;
    margin-right: 45px;
    background: #fff;
    border-radius: 10px;
}
.news-con ul p{
    font-size: 15px;
    margin: 15px 25px;
    text-align: left;
}
.news-item {
    width: 100%;
    height: 11.5%;
    overflow: hidden;
    margin-top: 8px;
}
.news-item img {
    width: 50px;
    height: 50px;
    border-radius: 100%;
}
.news-item img,
.news-item a {
    display: inline-block;
    vertical-align: middle;
}
.news-item a {
    width: 70%;
    text-overflow: ellipsis;
    line-height: 20px;
    padding-left: 10px;
    overflow: hidden;
    font-size: 12px;
    text-align: left;
}
</style>
<script>
export default {
    data() {
        return {
            newsOne: [
                {
                    img: 'news9.jpg',
                    href: 'https://www.dzwww.com/xinwen/shehuixinwen/202005/t20200519_19667071.htm',
                    mess: '“同心防疫，守护你我—— 未来会来”',
                },
                {
                    img: 'news10.jpg',
                    href: 'http://m.toutiao.hebtv.com/beifanghao/bftt2623700.html?hmsr=mo',
                    mess: '“同心防疫 守护你我” 当代艺术联展开幕 | 抗击新冠肺炎疫情',
                },
                {
                    img: 'news11.jpg',
                    href: 'http://gov.eastday.com/renda/tyzt/2017smxs/n30649/n30650/u1ai6260294_K5938.html',
                    mess: '“同心防疫，守护你我——未来会来”当代艺术联展开幕',
                },
                {
                    img: 'news12.jpg',
                    href: 'https://web.shobserver.com/wxShare/html/249284.htm?from=groupmessage&isappinstalled=0',
                    mess: '观众为何要逆时针观展？这场当代艺术联展希望我们记住这个时代',
                },
                {
                    img: 'news13.jpg',
                    href: 'http://www.why.com.cn/wx/article/2020/05/19/15898502491133801859.html?from=singlemessage&isappinstalled=0',
                    mess: '“二大”讲故事，“四大”敬英雄，各大红色展馆、特色博物馆线上线下各显神通',
                },
                {
                    img: 'news7.jpg',
                    href: 'http://wenhui.whb.cn/zhuzhanapp/cs/20200519/348618.html?timestamp=1589877760182&from=groupmessage&isappinstalled=0',
                    mess: '这场当代艺术联展用150余幅作品致敬疫情中逆行的英雄',
                },
                {
                    img: 'news8.jpg',
                    href:
                        'https://article.xuexi.cn/articles/index.html?art_id=11810530808044985870&item_id=11810530808044985870&study_style_id=feeds_default&pid=&ptype=-1&source=share&share_to=wx_single&from=groupmessage&isappinstalled=0',

                    mess: '【文艺抗疫】这场艺术展上，青年艺术家们用艺术作品向“逆行”英雄致敬',
                },
                {
                    img: 'neews9.jpg',
                    href: 'http://www.kankanews.com/a/2020-05-18/0039251926.shtml',
                    mess: '“同心防疫 守护你我” 当代艺术联展开幕',
                },
                {
                    img: '1.jpg',
                    href: 'https://mp.weixin.qq.com/s/Nf_2nJRcb9DYVfvtghiChQ',
                    mess: '中视文旅&国学频道【视频】同心防疫，守护你我 —— 未来会来 当代艺术联展在海派文化中心展出',
                },
            ],
            newsTwo: [
                {
                    img: 'news1.jpg',
                    href: 'https://mp.weixin.qq.com/s/aaXf39BHeAr094R9Tgxc2A',
                    mess: '直播一个展览的诞生给你看!',
                },
                {
                    img: 'news3.jpg',
                    href: 'https://mp.weixin.qq.com/s/n6OOnlX8C037eyG4VtBrqA',
                    mess: '从“不确定”里诞生出来的确定展，真的来了！开幕直播，敬请围观！',
                },
                {
                    img: 'news2.jpg',
                    href: 'https://mp.weixin.qq.com/s/oHPb09eoDK0zHPB6bJTs4g',
                    mess: '未来会来，我们确定。| “同心防疫，守护你我——未来会来当代艺术联展”正式开幕！',
                },
                {
                    img: 'news4.jpg',
                    href: 'https://mp.weixin.qq.com/s/mzI8_Q3pBBQhEusG4vFo2A',
                    mess: '未来会来，确定你的确定~ | 公众导览日+特别直播',
                },
                {
                    img: 'news5.jpg',
                    href: 'https://mp.weixin.qq.com/s/8EwqscgN7Zr9P0b9gGsKZQ',
                    mess: '周日的活动，推荐你参与~①在海派文化中心会有我们全日的导览，12:00线上直播~请来围观哟！',
                },
                {
                    img: 'news6.jpg',
                    href: 'https://m.thepaper.cn/newsDetail_forward_7795796',
                    mess: '未来会来，确定你的确定~ | 公众导览日+特别直播',
                },
                {
                    img: 'news14.jpg',
                    href: 'https://m.thepaper.cn/newsDetail_forward_7464531',
                    mess: '未来会来，确定你的确定~ | 公众导览日+特别直播',
                },
            ],
        };
    },
};
</script>
